import React from 'react';
import { Award, Zap, Fuel } from 'lucide-react';
import { aboutData } from '../../data/mock-v2';

const AboutV2 = () => {
  return (
    <section id="about" className="py-20 lg:py-32 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Contenido primero */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-[#63E61E]/10 rounded-full mb-4">
            <span className="text-[#63E61E] font-bold text-sm tracking-wide">SOBRE NOSOTROS</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-6">
            {aboutData.title}
          </h2>
          
          <div className="space-y-4 text-gray-700 leading-relaxed text-left">
            <p className="text-lg">{aboutData.description}</p>
            <p className="text-lg">{aboutData.description2}</p>
            <p className="text-lg">{aboutData.description3}</p>
          </div>

          {/* Value Proposition Highlight con diseño diferente */}
          <div className="bg-gradient-to-br from-[#63E61E] to-[#52c518] p-8 rounded-3xl mt-8 shadow-xl">
            <div className="flex items-start space-x-4 text-left">
              <Award className="w-8 h-8 text-gray-900 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-bold text-gray-900 text-xl mb-3">Nuestro Valor Agregado</h3>
                <p className="text-gray-900 font-medium">{aboutData.valueProposition}</p>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 pt-8">
            {aboutData.stats.map((stat, index) => (
              <div key={index} className="text-center bg-gray-50 py-4 rounded-xl">
                <div className="text-2xl lg:text-3xl font-black text-[#63E61E] mb-2">
                  {stat.number}
                </div>
                <div className="text-sm text-gray-600 font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Solo 2 imágenes minimalistas con diseño alternativo */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Vehículo Eléctrico con diseño moderno */}
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-br from-[#63E61E] to-[#52c518] rounded-3xl transform rotate-3 group-hover:rotate-6 transition-transform duration-500"></div>
            <div className="relative overflow-hidden rounded-3xl shadow-2xl transform -rotate-0 group-hover:rotate-1 transition-transform duration-500">
              <img
                src={aboutData.imageElectric}
                alt="Vehículo Eléctrico Cargando"
                className="w-full h-[400px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#63E61E]/50 to-transparent"></div>
              <div className="absolute top-6 right-6">
                <div className="bg-[#63E61E] p-3 rounded-full shadow-xl">
                  <Zap className="w-6 h-6 text-gray-900" />
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-gray-900 to-transparent p-6">
                <h3 className="text-white font-bold text-2xl mb-1">Vehículo Eléctrico</h3>
                <p className="text-gray-200 text-sm">Energía limpia y renovable</p>
              </div>
            </div>
          </div>

          {/* Vehículo a Gasolina con diseño moderno */}
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-br from-gray-600 to-gray-800 rounded-3xl transform -rotate-3 group-hover:-rotate-6 transition-transform duration-500"></div>
            <div className="relative overflow-hidden rounded-3xl shadow-2xl transform -rotate-0 group-hover:-rotate-1 transition-transform duration-500">
              <img
                src={aboutData.imageGasoline}
                alt="Vehículo a Gasolina"
                className="w-full h-[400px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/50 to-transparent"></div>
              <div className="absolute top-6 right-6">
                <div className="bg-white p-3 rounded-full shadow-xl">
                  <Fuel className="w-6 h-6 text-gray-900" />
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-gray-900 to-transparent p-6">
                <h3 className="text-white font-bold text-2xl mb-1">Vehículo a Gasolina</h3>
                <p className="text-gray-200 text-sm">Confiable y eficiente</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutV2;
